"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formReducer = function (state, action) {
    var _a;
    switch (action.type) {
        case 'Update': {
            var field = action.field, value = action.value;
            state.form[field] = value;
            validate(state, field, value);
            return __assign({}, state);
        }
        case 'Remove': {
            var field = action.field;
            delete state.form[field];
            return __assign({}, state);
        }
        case 'AddValidations': {
            var validation = state.validations.find(function (v) { return v.field === action.field; });
            if (validation) {
                (_a = validation.validations).push.apply(_a, action.validations);
            }
            else {
                state.validations.push({
                    field: action.field,
                    validations: action.validations,
                });
            }
            return __assign({}, state);
        }
        case 'RemoveValidations': {
            var validation = state.validations.find(function (v) { return v.field === action.field; });
            if (validation) {
                validation.validations = validation.validations.filter(function (v) { return !action.validations.includes(v); });
                delete state.validationStatus[action.field];
                delete state.messages[action.field];
            }
            return __assign({}, state);
        }
        case 'ShowValidationStatus': {
            state.messages[action.field] = action.status;
            return __assign({}, state);
        }
        case 'Submit': {
            var messages = {};
            if (Object.values(state.validationStatus).some(function (v) { return v.type !== "success" /* Success */; })) {
                messages = __assign({}, state.validationStatus);
                if (typeof action.onError === 'function') {
                    action.onError(messages);
                }
            }
            else {
                var form = Object.keys(state.form).reduce(function (current, key) {
                    var fieldValue = state.form[key];
                    var value = fieldValue && typeof fieldValue === 'object' ? fieldValue.value : fieldValue;
                    current[key] = value;
                    return current;
                }, {});
                action.submit(form, state);
            }
            return __assign(__assign({}, state), { messages: messages });
        }
        case 'Validate': {
            var field = action.field;
            var value = state.form[field];
            validate(state, field, value);
            return __assign({}, state);
        }
        default:
            return state;
    }
};
var validate = function (state, field, value) {
    var validation = state.validations.find(function (validation) { return validation.field === field; });
    if (validation) {
        var validationResult = validation.validations.find(function (v) { return !v.validate(value, state); });
        if (validationResult) {
            var validationStatus = {
                type: validationResult.type,
                message: validationResult.error,
            };
            state.validationStatus[field] = validationStatus;
        }
        else {
            delete state.validationStatus[field];
        }
    }
};
